var React = require('react');

function Arrow16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1893 7.25006L8.46967 4.53039L9.53033 3.46973L13.5303 7.46973C13.671 7.61038 13.75 7.80114 13.75 8.00006C13.75 8.19897 13.671 8.38973 13.5303 8.53039L9.53033 12.5304L8.46967 11.4697L11.1893 8.75006H3V7.25006H11.1893Z"}));
}

Arrow16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Arrow16;

Arrow16.default = Arrow16;
